import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-icon/jb-ref-icon.ts
import { html, LitElement, nothing, svg, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/components/jb-ref-icon/jb-ref-icon.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_icon_default = css`:host {
  display: inline-block;
  height: 100%;
}

svg {
  display: block;
  height: inherit;
  width: inherit;
}

svg,
path,
g,
rect {
  color: inherit;
}`;

// src/components/jb-ref-icon/jb-ref-icon.ts
var ICONS = {
  CHEVRON: {
    viewBox: "0 0 18 18",
    content: svg`<path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.58907 12.3013C9.26369 12.6273 8.73618 12.6273 8.41083 12.3013L2.94397 6.8248C2.61862 6.49887 2.6186 5.97043 2.94397 5.64448C3.26935 5.31852 3.79686 5.31855 4.12221 5.64448L8.99995 10.5309L13.8777 5.64448C14.2031 5.31853 14.7306 5.31855 15.0559 5.64448C15.3813 5.97041 15.3813 6.49884 15.0559 6.8248L9.58907 12.3013Z"
      fill="currentColor"
    />`
  },
  PLUS: {
    viewBox: "0 0 18 18",
    content: svg`<path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 2C8.44772 2 8 2.44772 8 3V8H3C2.44772 8 2 8.44772 2 9C2 9.55228 2.44772 10 3 10H8V15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15V10H15C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H10V3C10 2.44772 9.55228 2 9 2Z"
      fill="currentColor"
    />`
  },
  MINUS: {
    viewBox: "0 0 18 18",
    content: svg`<path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H3C2.44772 10 2 9.55228 2 9C2 8.44772 2.44772 8 3 8H15Z"
      fill="currentColor"
    />`
  },
  INFO: {
    viewBox: "0 0 18 18",
    content: svg`<g clip-path="url(#jb-ref-icon-info)">
      <rect
        width="16.8"
        height="16.8"
        x=".6"
        y=".6"
        stroke="currentColor"
        stroke-width="1.2"
        rx="8.4"
      />
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.813 6.056c.058-.134.087-.278.087-.431 0-.153-.03-.297-.087-.431A1.125 1.125 0 0 0 8.786 4.5c-.16 0-.31.03-.448.093a1.193 1.193 0 0 0-.36.246c-.102.102-.182.22-.24.355a1.075 1.075 0 0 0-.088.431c0 .153.03.297.087.431a1.133 1.133 0 0 0 .601.596c.138.058.288.087.448.087a1.115 1.115 0 0 0 .792-.328 1.2 1.2 0 0 0 .235-.355ZM7.879 7.92v5.58h1.78V7.919H7.88Z"
        clip-rule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="jb-ref-icon-info">
        <path
          fill="#fff"
          d="M0 0h18v18H0z"
        />
      </clipPath>
    </defs>`
  },
  PROFILE_THIN: {
    viewBox: "0 0 26 25",
    content: svg`<path
      d="M17.6398 7.81242C17.6398 10.6452 15.3434 12.9416 12.5107 12.9416C9.6779 12.9416 7.38149 10.6452 7.38149 7.81242C7.38149 4.97966 9.6779 2.68325 12.5107 2.68325C15.3434 2.68325 17.6398 4.97966 17.6398 7.81242Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.23468 22.743C3.89652 18.7167 7.79743 15.625 12.5107 15.625C17.224 15.625 21.1249 18.7167 21.7867 22.743"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />`
  }
};
var JbRefIcon = class extends LitElement {
  constructor() {
    super(...arguments);
    this.name = void 0;
  }
  render() {
    const icon = this.name ? ICONS[this.name] : void 0;
    if (!icon) return nothing;
    const [, , width, height] = icon.viewBox.split(" ");
    return html`<svg
      width="${width}"
      height="${height}"
      viewBox="${icon.viewBox}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      ${icon.content}
    </svg>`;
  }
};
JbRefIcon.styles = [unsafeCSS(jb_ref_icon_default)];
__decorateClass([
  property()
], JbRefIcon.prototype, "name", 2);
JbRefIcon = __decorateClass([
  customElement("jb-ref-icon")
], JbRefIcon);

export {
  JbRefIcon
};
